import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Navbar from '../nav/Navbar';


const MainLayout = ({ children, onLogout }) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState('/');
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <Navbar onLogout={onLogout} />
      <Box sx={{ p: 2, flexGrow: 1 }}>{children}</Box>
    </Box>
  );
};

export default MainLayout;
